export default {
  setCampaigns (state, data = []) {
    state.campaignItems = data
  },
  addCampaigns (state, data) {
    state.campaignItems = state.campaignItems.concat(data)
  },
  setLoadingPage (state, val = false) {
    state.loadingPage = val
  },
  setMeta (state, meta) {
    state.meta = {
      currentPage: meta?.current_page ?? 1,
      from: meta?.from ?? 1,
      lastPage: meta?.last_page ?? 1,
      perPage: meta?.per_page ?? 0,
      to: meta?.to ?? 0,
      total: meta?.total ?? 0,
    }
  },
  setLinks (state, links = {}) {
    state.links = links
  },
  setPermissions (state, permissions = []) {
    state.permissions = permissions
  },
}
